<template>
  <section class="sub_contents_wrap container">
    <div class="management_top_box">
      <h4>{{ $t("management.sendEmail") }}</h4>
    </div>
    <div class="brick_box">
      <p style="font-size: 0.5em">
        * {{ $t("alert.ifThereAreDuplicateItWillbeSendOnce") }}
      </p>
      <p style="font-size: 0.5em">
        * {{ $t("alert.youCanSendToMultipleWithMarking") }} =>
        <strong style="font-size: 10px">;</strong> ( ex : abc@email.com;def@email.com )
      </p>
      <table class="write_tbl responsive_tbl">
        <tbody>
          <tr>
            <th>{{ $t("management.template") }}</th>
            <td>
              <select
                @change="setMail(template)"
                v-model="template.templateId"
                class="int_type01 mgt_seltype"
              >
                <option value="">--select--</option>
                <option
                  v-for="(tem, index) in this.templateList"
                  :key="index"
                  :value="tem.templateId"
                >
                  {{ tem.title }}
                </option>
              </select>
            </td>
          </tr>
          <tr>
            <th>{{ $t("management.mailGroup") }}</th>
            <td>
              <div class="d-flex">
                <select
                  @change="setMailGroup(mailGroup)"
                  v-model="mailGroup.groupId"
                  class="int_type01 mgt_seltype"
                >
                  <option value="">--select--</option>
                  <option
                    v-for="(group, index) in this.mailGroupList"
                    :key="index"
                    :value="group.groupId"
                  >
                    {{ group.groupName }}
                  </option>
                </select>
              </div>
              <div>
                <ul v-if="this.groupRecipientList.length > 0" class="d-flex">
                  <li v-for="(rep, index) in this.groupRecipientList" :key="index">
                    {{ rep.groupName }}
                    <button
                      type="button"
                      @click="deleteGroup(rep, index)"
                      class="btn btn-secondary btn-sm p-1 m-1"
                    >
                      X
                    </button>
                  </li>
                </ul>
              </div>
            </td>
          </tr>
          <tr>
            <th>{{ $t("management.recipient") }}</th>
            <td>
              <textarea
                type="text"
                name="id"
                v-model="userMails"
                class="int_type01"
                sytle="overflow:auto"
              />
            </td>
          </tr>
          <tr>
            <th>{{ $t("common.title") }}</th>
            <td>
              <input
                type="text"
                name="mailTitle"
                v-model="mail.mailTitle"
                class="int_type01"
                v-validate="'required'"
              />
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <ckeditor
                class="textarea_type"
                name="mailContent"
                v-model="mail.mailContent"
                :config="editorConfig"
                v-validate="'required'"
              ></ckeditor>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="list_bottom_bt">
        <router-link
          to="/management/email/send"
          class="btn btn-outline-dark btn-lg m-1"
          >{{ $t("common.list") }}</router-link
        >
        <button type="button" @click="sendMail" class="btn btn-primary btn-lg m-1">
          {{ $t("common.send") }}
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import { sendMail, getSendMail } from "@/api/mail";
import { validateEmail } from "@/utils/validation";

export default {
  data() {
    return {
      doubleSubmitFlag: false,
      editorConfig: {
        toolbar: {
          items: [
            "heading",
            "|",
            "bold",
            "italic",
            "link",
            "undo",
            "redo",
            "bulletedList",
            "numberedList",
          ],
        },
      },
      mail: {},
      recpList: [],
      groupList: [],
      template: { templateId: "", title: "" },
      templateId: "",
      mailGroupList: [
        { groupId: "div_all", groupName: "All" },
        { groupId: "div_1", groupName: "Employees" },
        { groupId: "div_2", groupName: "Dealer" },
        { groupId: "div_3", groupName: "Users" },
      ],
      mailGroup: { groupId: "" },
      templateList: "",
      recipientList: [],
      groupRecipientList: [],
      form: {},
      userMails: "",
      recipMail: "",
      userList: [],
      sendGroup: { all: false, dealer: false, employee: false, user: false },
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    init() {
      this.mail = {};
      this.recpList = [];
      this.groupList = [];
      this.template = "";
      this.templateId = "";
      this.mailGroup = {};
      this.templateList = "";
      this.recipientList = [];
      this.form = {};
      this.userMails = "";
      this.recipMai = "";
      this.userList = [];
      this.groupRecipientList = [];
    },
    async fetchData() {
      try {
        this.mailId = this.$route.params.mailId;
        const { data } = await getSendMail(this.mailId);
        if (this.$route.params.mailId != null) {
          this.mail = data.mail;
          this.userMails = this.mail.emailList;
          this.recpList = data.recipGroupList;
          this.groupList = data.groupList;
          if (this.recpList.length > 0) {
            this.groupRecipientList = this.recpList;
          }
          // 전송한 메일중 그룹 확인
          // for (let i in this.recpList) {
          //   if (this.recpList[i].type == "GROUP") {
          //     this.mailGroup = {};
          //     this.mailGroup.groupId = "";
          //     this.mailGroup.groupName = "";
          //     this.mailGroup.groupId = this.recpList[i].id;
          //     this.mailGroup.groupName = this.recpList[i].name;
          //     this.groupRecipientList.push(this.mailGroup);
          //   } else {
          //     let recipMail = this.recpList[i].id + ";";
          //     this.userMails += recipMail;
          //   }
          // }

          if (this.mail.templateId != null) {
            this.template.templateId = this.mail.templateId;
            this.template.title = this.mail.title;
          }
        }
        for (let i = 0; i < data.groupList.length; i++) {
          this.mailGroupList.push(data.groupList[i]);
        }
        this.templateList = data.tempList;
      } catch (err) {
        console.log(err);
      }
    },
    async sendMail() {
      let loader = this.$loading.show({});
      const validForm = await this.$validator.validateAll();
      if (!validForm) return alert(this.$t("alert.plzCheckAllValues"));
      if (this.userMails != "") {
        let tempArray = this.userMails.split(";");
        for (let i = 0; i < tempArray.length; i++) {
          if (tempArray[i] != "" && !validateEmail(tempArray[i])) {
            alert(this.$t("alert.checkTheEmail"));
            return;
          }
          if (tempArray[i] != "") {
            this.userList.push({ emailAddress: tempArray[i] });
          }
        }
      }
      if (this.doubleSubmitFlag) {
        alert(this.$t("alert.itisBeingProcessed"));
        return false;
      } else {
        try {
          for (let j = 0; j < this.userList.length; j++) {
            // this.userList[j].groupId = "user";
            this.recipientList.push(this.userList[j]);
          }
          // 선택한 그룹 추가
          for (let g = 0; g < this.groupRecipientList.length; g++) {
            this.recipientList.push(this.groupRecipientList[g]);
          }
          this.mail.recipientList = this.recipientList;
          // 메일 아이디 초기화
          this.mail.id = null;
          this.mail.sendGroup = this.sendGroup;
          this.doubleSubmitFlag = true;
          // 이메일 전송
          const { data } = await sendMail(this.mail);
          this.doubleSubmitFlag = false;
          loader.hide();
          if (data.message != null) {
            alert(this.$t("alert.plzCheckAllValues"));
          }
          if (data.status) {
            alert(this.$t("alert.sendSuccessfully"));
            this.init();
            this.$router.push({ name: "emailSendMgmt" });
          } else {
            this.recipientList = [];
            alert(this.$t("alert.ErrorPlzcontactManager"));
          }
        } catch (err) {
          console.log(err);
          loader.hide();
        }
      }
    },
    setMail(template) {
      console.log(template);
      if (template.templateId == "") {
        this.mail.templateId = "";
        this.mail.mailTitle = "";
        this.mail.mailContent = "";
        return;
      }
      for (let i in this.templateList) {
        if (template.templateId == this.templateList[i].templateId) {
          this.mail.templateId = this.templateList[i].templateId;
          this.mail.mailTitle = this.templateList[i].title;
          this.mail.mailContent = this.templateList[i].content;
        }
      }
    },
    setMailGroup(mailGroup) {
      for (let i in this.groupRecipientList) {
        if (this.groupRecipientList[i].groupId == "all") {
          return;
        }
      }
      for (let i in this.mailGroupList) {
        if (mailGroup.groupId == this.mailGroupList[i].groupId) {
          if (mailGroup.groupId == "all") {
            this.groupRecipientList = [];
            this.groupRecipientList.push(this.mailGroupList[i]);
          } else {
            this.groupRecipientList.push(this.mailGroupList[i]);
          }
        }
      }
    },
    deleteGroup(rep, index) {
      this.groupRecipientList.splice(index, 1);
    },
    goCheckAll(checked) {
      this.sendGroup.all = checked;
      this.sendGroup.dealer = this.sendGroup.all;
      this.sendGroup.employee = this.sendGroup.all;
      this.sendGroup.user = this.sendGroup.all;
    },
    checkAllYN(checked) {
      if (!checked) {
        this.sendGroup.all = checked;
        return;
      }
      if (this.sendGroup.dealer && this.sendGroup.employee && this.sendGroup.user) {
        this.sendGroup.all = true;
      }
    },
  },
};
</script>

<style></style>
